module.exports = __webpack_public_path__ + "img/tongue.a2f61692.png";